import _ from "lodash";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";
import { ColumnFiltersState } from "@tanstack/react-table";

type Props = {
    androidVersions: string[];
    columnFilters: ColumnFiltersState;
    setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>;
    columnId?: string;
};

export const AndroidVersionHeader = ({
    androidVersions,
    columnFilters,
    setColumnFilters,
    columnId = "androidVersion",
}: Props) => {
    const { t } = useTranslation(["modals"]);
    const options = _.uniqBy(
        _.compact(androidVersions).map((v) => ({ key: v, label: v })),
        "key",
    );
    const current = (columnFilters.find((f) => f.id === columnId)?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.androidVersion")}
            defaultSortOrder="desc"
            options={options}
            initialValues={Object.fromEntries(options.map((o) => [o.key, current.includes(o.key)]))}
            onSubmit={(values) => {
                const value = Object.keys(values).filter((k) => values[k]);
                setColumnFilters((prev) => {
                    const rest = prev.filter((f) => f.id !== columnId);
                    return value.length ? [{ id: columnId, value }, ...rest] : rest;
                });
            }}
        />
    );
};
